const getResourceCaption = (resource) => {
  if ("data" in resource && resource.data && "caption" in resource.data && resource.data.caption) {
    return resource.data.caption;
  }
  return null;
};

export { getResourceCaption };
//# sourceMappingURL=getResourceCaption.js.map
